import React from 'react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS
// BREAKS THE AUTH. Se hace un redirect de página completa al backend, que inicia
// el flujo OAuth y luego vuelve a /auth/callback con el JWT.
const GoogleIcon = (props) => (
  <svg viewBox="0 0 48 48" width="18" height="18" aria-hidden="true" {...props}>
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.2C29.2 35.3 26.7 36 24 36c-5.3 0-9.7-3.1-11.3-7.6l-6.5 5C9.6 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.6l6.3 5.2C41.4 36 44 30.5 44 24c0-1.3-.1-2.3-.4-3.5z" />
  </svg>
);

export default function GoogleButton({ label = 'Continuar con Google' }) {
  const start = () => {
    const backend = process.env.REACT_APP_BACKEND_URL;
    window.location.href = `${backend}/api/auth/google/login`;
  };
  return (
    <button
      type="button"
      onClick={start}
      data-testid="google-login-btn"
      className="w-full inline-flex items-center justify-center gap-3 h-12 rounded-full border border-gray-300 bg-white text-habita-dark font-semibold hover:bg-gray-50 hover:border-gray-400 transition-colors"
    >
      <GoogleIcon />
      {label}
    </button>
  );
}
